export default __webpack_public_path__ + "static/media/unavailableTable.55d02a82.svg";